import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import styled from 'styled-components'

import colors from 'components/utils/colors'

import Badge from 'components/Shared/Badge/Index'
import Icon from 'components/Shared/Icon/Index'
import Select from 'components/Shared/Select/Index'
import FilterTitle from './FilterTitle'

const StyledWrapper = styled.div`
  display: flex;
  flex-flow: column;
  border-bottom: 1px solid ${colors.secondary70};
`

const StyledSelect = styled(Select)`
  && {
    margin: 0 10px 10px 9px;
    width: auto;
    min-height: 30px;
    max-height: fit-content;
    font-size: 14px;
  }
`

const StyledBadge = styled(Badge)`
  margin-left: 4px;
  margin-right: 4px;
  padding: 0 5px;
`

const StatusBadge = () => {
  return (
    <StyledBadge
      margin='0'
      color={colors.success73}
    >
      <Icon iconName='icon-status-new-12' color={colors.secondary40} />
    </StyledBadge>
  )
}

const FilterSectionStatuses = ({
  title, name, value, onChange, options, iconComponentsMap,
}) => {
  const active = value.length > 0
  const [value_, setValue_] = useState(value)
  const isEmpty = Boolean(!value_.length)

  useEffect(() => {
    setValue_(value)
  }, [value])

  const onActiveChange = (newActive) => {
    applyChanges(newActive ? value_ : [])
  }

  const onInputChange = (newValue) => {
    setValue_(newValue)
    if (active) {
      applyChanges(newValue)
    }
  }

  const applyChanges = (newValue) => {
    onChange?.({
      value: newValue,
      name: name,
    })
  }

  return (
    <StyledWrapper data-test='filter-with-icon'>
      <FilterTitle
        disabled={isEmpty}
        active={active}
        title={title}
        onActiveChange={onActiveChange}
        height={40}
        badge={<StatusBadge />}
      />
      <StyledSelect
        multiselect
        small
        value={value_}
        onChange={onInputChange}
        options={options}
        iconComponentsMap={iconComponentsMap}
      />
    </StyledWrapper>
  )
}

FilterSectionStatuses.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  iconComponentsMap: PropTypes.object,
}

export default FilterSectionStatuses
